import type { CommentLinkProps } from "./comment-link.type";

import { TAB_KEYS, TAB_PARAM_KEYS } from "@/constants/TabKeys";
import { ModelLink } from "@/modules/model-link";

export const CommentLink = ({
  intervention,
  observation,
  ...modelLinkProps
}: CommentLinkProps) => {
  const commentsTab = `${TAB_PARAM_KEYS.CONTEXT_SUBTAB_KEY}=${TAB_KEYS.OBSERVATIONS_COMMENTS}`;

  return (
    <ModelLink
      model="intervention"
      item={{ id: intervention.id, name: intervention.name }}
      search={`?observation_id=${observation.id}&${commentsTab}`}
      showIcon
      modelAsName
      customModel="comment"
      {...modelLinkProps}
    />
  );
};
